import React from "react";

import {
  CONTACT_INFO,
  PLANS,
  GYM_AREAS,
  WHY_JOIN,
  TRAINERS,
  HERO_IMAGE,
  ATHLETE_IMAGES,
  QUOTES,
} from "./GymData";

function HomePage({
  onLogin,
  onSignup,
  onEnquire,
  darkMode,
  setDarkMode,
}) {
  return (
    <div className="home-page">

      {/* ================= NAVBAR ================= */}

      <nav className="landing-nav">

        <div className="logo">
          FIT<span>RACK</span>
        </div>

        <div className="landing-links">
          <a href="#home">Home</a>
          <a href="#why-join">Why Join</a>
          <a href="#areas">Gym</a>
          <a href="#plans">Plans</a>
          <a href="#trainers">Trainers</a>
        </div>

        <div className="nav-actions">

          <button
            className="theme-toggle"
            onClick={() => setDarkMode(!darkMode)}
          >
            {darkMode ? "☀ Day Version" : "🌙 Night Version"}
          </button>

          <button className="nav-login" onClick={onLogin}>
            Login
          </button>

          <button className="nav-signup" onClick={onSignup}>
            Sign Up
          </button>

        </div>
      </nav>


      {/* ================= HERO ================= */}

      <section
        className="hero-section"
        id="home"
        style={{
          backgroundImage: `linear-gradient(
            90deg,
            rgba(0,0,0,0.95),
            rgba(0,0,0,0.55),
            rgba(0,0,0,0.25)
          ), url(${HERO_IMAGE})`,
        }}
      >

        <div className="hero-content">

          <p className="hero-small">
            WELCOME TO FITRACK
          </p>

          <h1>
            BUILD YOUR
            <br />
            <span>STRONGER</span>
            <br />
            SELF.
          </h1>

          <p className="hero-text">
            Train harder. Stay consistent. Become stronger.
            FITRACK gives you the environment, equipment and
            support to keep moving forward.
          </p>

          <div className="hero-buttons">

            <button
              className="primary-button glow-button"
              onClick={onSignup}
            >
              JOIN FITRACK →
            </button>

            <button
              className="outline-button"
              onClick={onEnquire}
            >
              ENQUIRE NOW
            </button>

          </div>

        </div>

      </section>


      {/* ================= WHY JOIN ================= */}

      <section className="section" id="why-join">

        <div className="section-heading">

          <p className="orange-text">
            WHY FITRACK?
          </p>

          <h2>
            WHY YOU SHOULD
            <br />
            <span>JOIN FITRACK</span>
          </h2>

          <p>
            More than just a gym. A place where you can
            train, improve and stay consistent.
          </p>

        </div>


        <div className="why-grid">

          {WHY_JOIN.map((item, index) => (
            <div className="why-card" key={index}>

              <div className="why-icon">
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.text}</p>

            </div>
          ))}

        </div>

      </section>


      {/* ================= GYM AREAS ================= */}

      <section className="section dark-section" id="areas">

        <div className="section-heading">

          <p className="orange-text">
            TRAIN YOUR WAY
          </p>

          <h2>
            OUR <span>GYM AREAS</span>
          </h2>

        </div>


        <div className="areas-grid">

          {GYM_AREAS.map((area, index) => (
            <div className="area-card" key={index}>

              <div className="area-number">
                0{index + 1}
              </div>

              <h3>{area.title}</h3>

              <p>{area.description}</p>

              <span className="area-arrow">
                →
              </span>

            </div>
          ))}

        </div>

      </section>


      {/* ================= MEMBERSHIP ================= */}

      <section className="section" id="plans">

        <div className="section-heading">

          <p className="orange-text">
            MEMBERSHIP
          </p>

          <h2>
            CHOOSE YOUR
            <br />
            <span>PLAN</span>
          </h2>

        </div>


        <div className="plans-grid">

          {PLANS.map((plan, index) => (
            <div
              className={`plan-card ${
                index === 1 ? "featured-plan" : ""
              }`}
              key={index}
            >

              {index === 1 && (
                <div className="popular-tag">
                  POPULAR
                </div>
              )}

              <h3>{plan.name}</h3>

              <div className="plan-price">
                ₹{plan.price}
              </div>

              <p>{plan.duration}</p>

              <button
                className="primary-button"
                onClick={onSignup}
              >
                JOIN NOW →
              </button>

            </div>
          ))}

        </div>

      </section>


      {/* ================= TRAINERS ================= */}

      <section className="section dark-section" id="trainers">

        <div className="section-heading">

          <p className="orange-text">
            OUR TEAM
          </p>

          <h2>
            MEET OUR
            <br />
            <span>TRAINERS</span>
          </h2>

          <p>
            Get guidance and support from our fitness team.
          </p>

        </div>


        <div className="trainers-grid">

          {TRAINERS.map((trainer, index) => (
            <div className="trainer-card" key={index}>

              <div className="trainer-image">

                <img
                  src={trainer.image}
                  alt={trainer.name}
                />

              </div>

              <div className="trainer-info">

                <p className="orange-text">
                  {trainer.role}
                </p>

                <h3>{trainer.name}</h3>

                <p>
                  Training Time:
                  <br />
                  <strong>{trainer.timing}</strong>
                </p>

              </div>

            </div>
          ))}

        </div>

      </section>


      {/* ================= ATHLETE SECTION ================= */}

      <section className="athlete-section">

        <div className="athlete-text">

          <p className="orange-text">
            TRAIN WITH PURPOSE
          </p>

          <h2>
            NO EXCUSES.
            <br />
            JUST <span>PROGRESS.</span>
          </h2>

          <p>
            Every workout is another step towards becoming
            stronger, healthier and more confident.
          </p>

          <button
            className="primary-button glow-button"
            onClick={onSignup}
          >
            START TRAINING →
          </button>

        </div>


        <div className="athlete-images">

          {ATHLETE_IMAGES.map((image, index) => (
            <img
              src={image}
              alt="FITRACK training"
              key={index}
            />
          ))}

        </div>

      </section>


      {/* ================= QUOTE ================= */}

      <section className="quote-section">

        <div className="quote-mark">
          "
        </div>

        <h2>
          {QUOTES[0]}
        </h2>

        <p>
          — FITRACK
        </p>

      </section>


      {/* ================= ENQUIRE CTA ================= */}

      <section className="enquire-cta">

        <div>

          <p className="orange-text">
            HAVE QUESTIONS?
          </p>

          <h2>
            WANT TO KNOW MORE
            <br />
            ABOUT <span>FITRACK?</span>
          </h2>

          <p>
            Send us your details and our team will get
            in touch with you.
          </p>

        </div>


        <button
          className="enquire-glow-button"
          onClick={onEnquire}
        >
          SEND US A MESSAGE →
        </button>

      </section>


      {/* ================= LOCATION ================= */}

      <section className="location-section">

        <div>

          <p className="orange-text">
            FIND US
          </p>

          <h2>
            FITRACK
            <br />
            <span>MOHALI</span>
          </h2>

          <p>
            📍 {CONTACT_INFO.location}
          </p>

          <p>
            ✉ {CONTACT_INFO.email}
          </p>

        </div>


        <a
          className="map-button"
          href={CONTACT_INFO.map}
          target="_blank"
          rel="noreferrer"
        >
          OPEN MAP →
        </a>

      </section>


      {/* ================= FOOTER ================= */}

      <footer className="footer">

        <div className="logo">
          FIT<span>RACK</span>
        </div>

        <p>
          Train. Improve. Repeat.
        </p>

        <p>
          © {new Date().getFullYear()} FITRACK. All rights reserved.
        </p>

      </footer>

    </div>
  );
}

export default HomePage;